import { Grid, GridItem, Heading } from '@which/seatbelt'

import classNames from 'classnames'

import type { RecommendedContentType } from '../../models'
import { RecommendationCard } from '../layoutElements/RecommendationCard'
import styles from './RecommendationsTwoByTwoLayout.module.scss'

type RecommendedTwoByTwoLayoutProps = {
  recommendations: RecommendedContentType[]
  title: string
  whichId: string
  modelId: string
  consentBannerComponent?: React.ReactNode
}

export const RecommendationsTwoByTwoLayout = ({
  recommendations,
  title,
  whichId,
  modelId,
  consentBannerComponent = null,
}: RecommendedTwoByTwoLayoutProps) => (
  <Grid data-testid={'r4u-2x2'} className={classNames('w-page-wrapper', styles.sectionSpacing)}>
    <GridItem
      columnStart={{ large: 2 }}
      span={{ large: 10 }}
      className={styles.mobileMaxWidthWrapper}
    >
      <Heading headingType="large" heading={title} headingTag="h2" />

      <div className={styles.recommendedArticlesContainer}>
        {recommendations?.map((recommendation, index) => (
          <RecommendationCard
            recommendation={recommendation}
            whichId={whichId}
            modelId={modelId}
            index={index}
            key={recommendation.id}
            large={false}
            sectionTitle={title}
          />
        ))}
      </div>
    </GridItem>
    {consentBannerComponent && <GridItem>{consentBannerComponent}</GridItem>}
  </Grid>
)
